<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-md-8">
        <input type="text" class="hidden" />
      </div>
      <div class="col-md-2">
        <input type="file" #fileMultiPle class="hidden" (change)="uploadMultipeFiles($event)" multiple 
        accept=".xlsx, .xls, .csv, .jpg, .doc, .docx, .txt, .pdf, .ppt, .mp4, .zip"/>
        <button class="btn-sm btn btn-primary aploadMany" type="Submit" (click)="fileMultiPle.click()">
          <span id="uploadAll">Upload All</span>
          <em class="fa fa-upload" *ngIf="!uloadLoader"></em>
          <em class="fa fa-circle-o-notch fa-spin" *ngIf="uloadLoader"></em>
        </button>
        </div>
        <div class="col-md-2">
        <button class="btn-sm btn btn-primary" type="Submit" [disabled]="uploadedFiles.length < 2"
          (click)="downloadAllFiles()">
          <span id="downloadAll">Download All</span>
          <em class="fa fa-download" *ngIf="!loader"></em>
          <em class="fa fa-circle-o-notch fa-spin" *ngIf="loader"></em>
        </button>
      </div>
    </div>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-1 h1-text">
        <label>Sr. No.</label>
      </div>
      <div class="col-md-5 h1-text">
        <label>Type of Document</label>
      </div>
      <div class="col-md-3 h1-text">
        <label>Select File</label>
      </div>
      <!-- <div class="col-md-1 h1-text" *ngIf="userAllow?.length > 0"> -->
        <div class="col-md-1 h1-text">
        <label>Generate</label>
      </div>
    </div>
    <div class="row" *ngFor="let docList of documents; let i = index;">
      <input type="file" #file class="hidden" (change)="uploadFile($event, docList, getDocumentId(docList?.srNo))"
        accept=".xlsx, .xls, .csv, .jpg, .doc, .docx, .txt, .pdf, .ppt, .mp4, .zip">
      <div class="col-md-1">
        <label>{{docList?.srNo}}</label>
      </div>
      <div class="col-md-5">
        <label>{{docList?.documentName}}</label>
      </div>
      <div class="col-md-3">
        <label class="input-group">
          <input class="form-control ng-untouched ng-pristine" [value]="getFileUploded(docList?.srNo)"
            data-toggle="tooltip" type="text" disabled>
          <a [href]="getFileURL(docList?.srNo)" class="input-group-addon default" *ngIf="getFileURL(docList?.srNo)">
            <em class="fa fa-download"></em>
          </a>
          <span class="input-group-addon warning">
            <em class="fa fa-upload" (click)="file.click()"></em>
          </span>
        </label>
      </div>
      <!-- <div class="col-md-1 input-group" *ngIf="userAllow?.length > 0"> -->
        <div class="col-md-1" *ngIf="docList.dataEntryAccessRights || docList.docAccessRights">
        <!-- <a [routerLink]="['/ncd/document/generation/mster/setup/document/for/', issueId, docList?._id, docList.srNo]"> -->
          <!-- *ngIf="filterValidatiopn(docList?._id)"> -->
          <button type="button" class="btn-sm btn btn-warning" (click)="openEditComponent(docList?._id, docList.srNo )">
            <span class="fa fa-pencil">
            </span>
          </button>
        <!-- </a> -->
      </div>
    </div>
  </div>
</section>
